// @flow

export { WithholdTaxes } from './types';
export { getWithholdTaxes } from './get-withhold-taxes';
export { formatWithholdTaxesDocumentText } from './format-withhold-taxes-document-text';
export { formatWithholdTaxesInstructionTextWithAmount } from './format-withhold-taxes-instruction-text-with-amount';
export { formatWithholdTaxesTitleText } from './format-withhold-taxes-title-text';
export { formatWithholdTaxesInstructionTextCertificate } from './format-withhold-taxes-instruction-text-certificate';
export { TextInstructionWithholdTaxesByCustomer } from './text-instruction-withhold-taxes-by-customer';
